module.exports = __webpack_public_path__ + "img/text-color.8f03a8ab.svg";